export function isFacebook(link: string) {
    return link.indexOf('https://www.facebook.com') >= 0
}

/**
 * See Url formats in https://developers.facebook.com/docs/plugins/oembed/#url-formats
 */
export function determineApiRoute(link: string) {
    const videoExp = /.*(\/videos\/|\/video.php\?)+.*/
    const videosMatch = videoExp.exec(link)

    if (videosMatch && videosMatch[0]) {
        return 'oembed_video'
    }

    const reelExp = /.*(\/reel\/|\/reel.php\?).*/
    const reelMatch = reelExp.exec(link)

    if (reelMatch && reelMatch[0]) {
        return 'oembed_video'
    }

    const postExp =
    /.*(\/posts\/|\/activity\/|\/questions\/|\/notes\/|\/photos\/|\/photo.php\?|\/permalink.php\?|\/media\/set\?|\/watch\/?\?v=)+.*/
    const postMatch = postExp.exec(link)

    if (postMatch && postMatch[0]) {
        return 'oembed_post'
    }

    // NO match at this point must be a page
    return 'oembed_page'
}

// Init func to ensure FB init is called once on multiple fb embeds on one page
export declare const FB: { init: (params: any) => void }
let initFunc: NodeJS.Timeout | null = null

export function initFb(fbAppId: string) {
    if (initFunc) {
        clearTimeout(initFunc)
        initFunc = null
    }

    initFunc = setTimeout(() => {
        FB.init({ appId: fbAppId, status: false, xfbml: true, version: 'v2.7' })
    }, 200)
}
